import Vue from 'vue';
import ToastComponent from './index.vue';
let ToastConstructor = Vue.extend(ToastComponent);

let Toast = function (obj = {
    type: 'none',
    title: '',
    duration: 1500,
    mask: true,
}) {
    let data = typeof obj == 'string' ? {
        type: 'none',
        title: obj,
        duration: 1500,
        mask: true
    } : obj;
    let instance = new ToastConstructor({
        data,
    })
    instance.$mount();
    document.body.appendChild(instance.$el)
    return instance;
}

let install = function (Vue) {
    Vue.prototype.$yxToast = Toast;
    Vue.prototype.$yxToast.hideLoading = function () {
        let existEle = document.querySelector('#yxToast');
        if (existEle) {
            document.body.removeChild(existEle)
        }
    }
}
export default install;



// WEBPACK FOOTER //
// ./src/components/yx-toast/index.js